import Colors from '@/constants/Colors';
import MediaQueryBreakpoints from '@/constants/MediaQueryBreakpoints';
import styled from 'styled-components';

export const StyledOptionsPage = styled.div`
  width: 100%;
  height: 100%;
  .text {
    font-size: 120%;
    display: flex;
    align-items: center;
    gap: 20px;
  }
  .options {
    width: 80%;
    margin-top: 20px;
    background-color: ${Colors.backgroundPaleBlueDark};
    border-radius: 20px;
    padding: 20px 10px 20px 40px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    .option-with-audio {
      width: 100%;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .audio-player {
        position: absolute;
        left: -20px;
        top: calc(50% - 20px);
      }
      .option {
        flex: 1;
        display: flex;
        gap: 20px;
        align-items: center;
        justify-content: space-between;
        border-radius: 20px;
        padding: 10px 40px;
        .option-icon {
          cursor: pointer;
        }
        .option-text {
          user-select: none;
        }
        .true-false {
          display: flex;
          box-shadow: -1px 1px 1px 1px ${Colors.lightGray};
          border-radius: 30px;
          position: relative;
          button {
            font-size: 90%;
            line-height: 1.2;
            background-color: ${Colors.backgroundPaleBlue};
            :hover {
              background-color: ${Colors.backgroundPaleBlueDark};
            }
            &.selected {
              background-color: ${Colors.primary};
              color: ${Colors.background};
            }
          }
          .btn-wrap-true {
            display: inline-block;
            border: 8px solid ${Colors.background};
            border-radius: 30px 0 0 30px;
            border-right: none;
            button {
              border-radius: 20px 4px 4px 20px;
            }
          }
          .btn-wrap-false {
            display: inline-block;
            border: 8px solid ${Colors.background};
            border-radius: 0 30px 30px 0;
            border-left: none;

            button {
              border-radius: 4px 20px 20px 4px;
            }
          }
        }
        .feedback {
          position: absolute;
          right: -62%;
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  @media only screen and (max-height: 500px) and (orientation: landscape) {
    .text {
      font-size: 105%;
    }
    .options {
      gap: 4px;
      width: 100%;
      .option-with-audio {
        .audio-player {
          width: 32px;
          height: 32px;
          top: calc(50% - 16px);
        }
        .option {
          padding: 0 40px;
          .option-icon {
            width: 36px;
            height: 36px;
          }
          .true-false {
            .btn-wrap-true {
              border: 4px solid ${Colors.background};
              border-right: none;
            }

            .btn-wrap-false {
              border: 4px solid ${Colors.background};
              border-left: none;
            }
            button {
              line-height: 0.8;
              height: 30px;
            }
          }
        }
      }
    }
  }

  @media only screen and (max-width: ${MediaQueryBreakpoints.md}) {
    .options .option {
      flex-direction: column;
    }
  }
`;
